// Dev-only logging — silenced in production builds (CRA sets NODE_ENV=production).
const isDev = process.env.NODE_ENV !== 'production';

export const devWarn = (...args) => {
  if (isDev) console.warn(...args);
};

export const devDebug = (...args) => {
  if (isDev) console.debug(...args);
};
